import { supabase } from '../lib/supabase'
import type { InboxItemType } from '../types/inbox'

export interface InboxItemNote {
  id: string
  entity_type: InboxItemType
  entity_id: string
  body: string
  created_by: string | null
  created_by_name: string | null
  created_at: string
}

const NOTE_FIELDS =
  'id, entity_type, entity_id, body, created_by, created_by_name, created_at'

export async function fetchInboxItemNotes(
  entityType: InboxItemType,
  entityId: string
): Promise<InboxItemNote[]> {
  const { data, error } = await supabase
    .from('inbox_item_notes')
    .select(NOTE_FIELDS)
    .eq('entity_type', entityType)
    .eq('entity_id', entityId)
    .order('created_at', { ascending: false })

  if (error) throw error
  return (data || []) as InboxItemNote[]
}

export async function countInboxItemNotes(
  entityType: InboxItemType,
  entityId: string
): Promise<number> {
  const { count, error } = await supabase
    .from('inbox_item_notes')
    .select('id', { count: 'exact', head: true })
    .eq('entity_type', entityType)
    .eq('entity_id', entityId)

  if (error) throw error
  return count || 0
}

export async function createInboxItemNote(input: {
  entityType: InboxItemType
  entityId: string
  body: string
  createdByName?: string | null
}): Promise<InboxItemNote> {
  const { data, error } = await supabase
    .from('inbox_item_notes')
    .insert({
      entity_type: input.entityType,
      entity_id: input.entityId,
      body: input.body.trim(),
      created_by_name: input.createdByName?.trim() || null,
    })
    .select(NOTE_FIELDS)
    .single()

  if (error) throw error
  return data as InboxItemNote
}
